import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';


const TOSModal = ({ show, handleClose }) => {

    const handleCancel = () => {
        window.location.reload()
    }

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title>Acumen Translation Hub says</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <p>The input file has more than 20 pages. This can be translated with
                        batch translation.
                        This might take longer to translate and will be charged per page basis.</p>
                    <p>
                        By clicking Continue you agree to our Terms & Conditions and Privacy Statement.
                        Click Cancel to exit translation
                    </p>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleClose}>
                    Continue
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TOSModal;
